/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  
  /**
   * Прелоадер.
   *
   * Вставка прелоадера происходит в body по центру экрана.
   */
  app.PreloaderView = app.View.extend({
    id: 'circularG',
    className: 'preloader',
    templateId: '#preloader',
    canRender: true,
    isNewInfiniteLoader: false,
    
    run: function () {
      this.model = new app.Preloader();
      this.infinitePreloaderTemplate = app.helpers.TemplateHelper.getTemplate(this.templateId);
    },
    
    remove: function () {
      this.model.set('isActivePreloader', false);
      this.$el.remove();
      this.stopListening();
      return this;
    },
    
    render: function (qtyShown, qtyTotal) {
      if (this.canRender) {
        var top = $(window).scrollTop() + $(window).height() / 2;
        this.$el.html(this.infinitePreloaderTemplate({
          qty: {
            shown: qtyShown,
            total: qtyTotal,
          },
          isNewInfiniteLoader: this.isNewInfiniteLoader,
        }));
        if (qtyShown && qtyTotal) {
          this.$el.addClass('infinite-preloader');
          this.$el.appendTo('.infinityScrollData');
        } else {
          this.$el.removeClass('infinite-preloader');
          this.$el.css({'top': top});
          this.$el.appendTo('body');
        }
        this.model.set('isActivePreloader', true);

        return this;
      }
    }
    
  });
  
  app.preloader = new app.PreloaderView();
})(jQuery);

}.call(window));